module.exports = __webpack_public_path__ + "img/specialeffects-1_jp.171d7a3.jpg";